import { render, staticRenderFns } from "./ModernDialog.vue?vue&type=template&id=55bca6d9&"
import script from "./ModernDialog.vue?vue&type=script&lang=js&"
export * from "./ModernDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports